import React, { useEffect, useRef, useState } from 'react';
import InputField from '../InputField';
import UploadImage from '../UploadImage'
import useAxios from '../../../hooks/useAxios';

const Main = ({ id }) => {
    const { AxiosPrivate } = useAxios()
    const [data, setData] = useState({ baner: [] })
    const [refresh, setRefresh] = useState()
    const errors = {}
    const touch = { header1: true, header2: true, text1: true, text2: true, text3: true, header3: true, header4: true, }
    const update = useRef(null)
    const isChanged = useRef(false)

    useEffect(() => {
        const get = async () => {
            await AxiosPrivate.get(`/baners/${id}`)
                .then(res => {
                    setData(res.data.data)
                    update.current.innerText = `ویرایش: ${new Date(res.data.data.updated_at).toLocaleString('fa-IR')}`
                })
                .catch(err => alert(err.response?.data.message))
        }
        get()
    }, [refresh])

    const handleChange = (e) => {
        const { name, value } = e.target
        isChanged.current = true
        setData(prev => {
            return {
                ...prev,
                [name]: value
            }
        })
    }
    const handleSumbit = async () => {
        if (Object.keys(errors).length) {
            return
        } else {
            let Data = {};
            if (data.baner[0].id) { Data = { ...data, baner: null } } else Data = data;
            await AxiosPrivate.put(`/baners/${id}`, { ...Data, _method: "PUT" })
                .then(res => {
                    alert(res.data.messgae || 'با موفقیت ویرایش شدند')
                    isChanged.current = false
                    setRefresh(Math.random())
                })
                .catch(err => alert(err.response?.data.message || 'مشکلی رخ داده است'))
        }
    }
    return (
        <>
            <div className="">
                <form action="" className='flex flex-col mb-4'>
                    <InputField label={'بنر 1'} id={1} max_width={'100%'} name={'header1'} type={'text'}  {...{ data, handleChange, touch, errors }} />
                    <InputField label={'بنر 2'} id={2} max_width={'100%'} name={'header2'} type={'text'}  {...{ data, handleChange, touch, errors }} />
                    <div className="relative pb-6 mb-4 max-w-[100%] w-full">
                        <UploadImage setData={setData} errors={errors} touch={touch} label='عکس بنر' name='baner' images={data.baner} />
                    </div>
                    <InputField label={'تکست 1'} id={3} max_width={'100%'} name={'text1'} type={'text'}  {...{ data, handleChange, touch, errors }} />
                    <InputField label={'تکست 2'} id={4} max_width={'100%'} name={'text2'} type={'text'}  {...{ data, handleChange, touch, errors }} />
                    <InputField label={'تکست 3'} id={5} max_width={'100%'} name={'text3'} type={'text'}  {...{ data, handleChange, touch, errors }} />
                    {id != 1 && <InputField label={'هد 1'} id={6} max_width={'100%'} name={'header3'} type={'text'}  {...{ data, handleChange, touch, errors }} />}
                    {id != 1 && <InputField label={'هد 2'} id={7} max_width={'100%'} name={'header4'} type={'text'}  {...{ data, handleChange, touch, errors }} />}
                    <InputField label={'تایتل'} id={8} max_width={'100%'} name={'seo_title'} type={'text'}  {...{ data, handleChange, touch, errors }} />
                    <InputField label={'دیسکریپشن'} id={10} max_width={'100%'} name={'meta_description'} type={'text'}  {...{ data, handleChange, touch, errors }} />
                    {isChanged.current && <button onClick={handleSumbit} type="button" className="text-white w-fit bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br 
                     focus:outline-none shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 ">ویرایش</button>}
                </form>
                <div className="w-full flex sm:items-center items-start gap-4 sm:text-base text-sm sm:flex-row flex-col">
                    <p ref={update}></p>
                </div>
            </div>
        </>
    );
};

export default Main;